/* TEST-008 — Mobile sticky ATC: "Pick your setup" → Add to Cart
 * --------------------------------------------------------------
 * MOBILE ONLY (< 768px viewport). Desktop sticky is left untouched —
 * main-product.js's existing scroll-trigger handler runs as today.
 *
 * Arms:
 *   control: untouched on any device.
 *   A: on mobile, pin the sticky bar visible from page load. The sticky CTA
 *      starts as "Pick your setup" (the existing data-configure button,
 *      relabeled — still scrolls to [data-product-info] / variant selectors
 *      on click via the theme's existing handler). The sticky CTA
 *      PERMANENTLY swaps to the Add-to-Cart button once the variant
 *      selectors enter the viewport for the first time. A default variant
 *      is always pre-selected, so once the user has SEEN the picker they
 *      can ATC even without changing anything.
 *
 * URL override: ?cl_sticky_v=control|a
 * TEST_MODE='live' default.
 */
(function(){
  'use strict';
  var TEST_ID='pdp_sticky_atc', COOKIE='cl_sticky_v4', PARAM='cl_sticky_v', TTL=30;
  var SPLIT=[{a:'a',w:100}];
  var VALID={control:1,a:1};
  var TEST_MODE='live';
  var MOBILE_MQ = '(max-width: 767px)';

  // ─── Metafield override ─── mirrors stix-no-tour-tax-test.js + snippets/cro-config-global.liquid.
  // Read shop.metafields.cro.test_config[TEST_ID] from the page-global emitted by
  // cro-config-global.liquid. If present, REPLACE the hardcoded SPLIT + VALID above so
  // weight/status changes via Scripts/cro_config.py take effect on next page load WITHOUT a
  // theme deploy. This closes the recurring "metafield doesn't drive the storefront" bug for
  // sticky_atc. Falls back to the hardcoded defaults when the global is missing (dev/preview).
  try {
    var __mf = window.STIX_CRO_CONFIG && window.STIX_CRO_CONFIG[TEST_ID];
    if (__mf && __mf.variants && __mf.variants.length) {
      SPLIT = __mf.variants.map(function(v){ return {a: v.label, w: v.weight}; });
      VALID = {};
      __mf.variants.forEach(function(v){ VALID[v.label] = 1; });
      if (__mf.status === 'paused' || __mf.status === 'reverted') TEST_MODE = 'smoke';
      window.STIX_TEST_SOURCE = (window.STIX_TEST_SOURCE||{}); window.STIX_TEST_SOURCE[TEST_ID] = 'metafield';
    } else {
      window.STIX_TEST_SOURCE = (window.STIX_TEST_SOURCE||{}); window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded';
    }
  } catch(e){}

  function gc(n){var m=document.cookie.match(new RegExp('(?:^|;\\s*)'+n+'=([^;]*)'));return m?decodeURIComponent(m[1]):null;}
  function sc(n,v,d){var x=new Date();x.setTime(x.getTime()+d*86400000);document.cookie=n+'='+encodeURIComponent(v)+'; expires='+x.toUTCString()+'; path=/; SameSite=Lax';}
  function ovr(){try{var p=new URLSearchParams(location.search).get(PARAM);if(!p) return null; p=p.toLowerCase(); return VALID[p]?p:null;}catch(e){return null;}}
  function pick(){var r=Math.random()*100,c=0;for(var i=0;i<SPLIT.length;i++){c+=SPLIT[i].w;if(r<c)return SPLIT[i].a;}return SPLIT[0].a;}
  function isBot(){return /bot|crawl|spider|slurp|duckduckbot|baiduspider|yandex|bingpreview|facebookexternalhit|embedly|lighthouse|headlesschrome/i.test(navigator.userAgent||'');}
  function isMobile(){ try { return window.matchMedia(MOBILE_MQ).matches; } catch(e){ return false; } }

  function init(){
    if(!document.querySelector('[data-cl-sticky-router]')) return;
    var arm=ovr(), fromUrl=!!arm;
    if(!arm){
      if(TEST_MODE==='smoke') arm='control';
      else if(isBot()) arm='control';
      else{arm=gc(COOKIE); if(!arm||!VALID[arm]){arm=pick(); sc(COOKIE,arm,TTL);}}
    } else { sc(COOKIE,arm,TTL); }
    window.STIX_TEST=window.STIX_TEST||{}; window.STIX_TEST[TEST_ID]=arm;
    if (typeof window.stixCroExpose === "function") { window.stixCroExpose(TEST_ID, arm, { page_type: "pdp" }); }
    document.documentElement.setAttribute('data-cl-sticky-arm',arm);
    if(arm==='a' && isMobile()) applyArmA();
    var track=(new URLSearchParams(location.search).get('cl_sticky_track')==='1');
    if(TEST_MODE==='live'||(fromUrl&&track)) fire(arm);
  }

  function applyArmA(){
    function attempt(){
      var sticky = document.querySelector('[data-product-sticky]');
      if(!sticky) return false;

      var stickyConfigure = sticky.querySelector('[data-configure]');
      if(!stickyConfigure) return false;

      // Pin sticky visible (also enforced by CSS in cl-sticky-atc-test.liquid
      // with !important, but adding the .sticky class keeps the theme's
      // transform state in sync).
      sticky.classList.add('sticky');
      var pinner = new MutationObserver(function(){
        if(!sticky.classList.contains('sticky')) sticky.classList.add('sticky');
      });
      pinner.observe(sticky, { attributes:true, attributeFilter:['class'] });

      // Stage 1: relabel the Configure button "Pick your setup". CSS handles
      // which button is visible (toggled via [data-cl-sticky-stage] on <html>).
      if(!stickyConfigure.hasAttribute('data-cl-orig-text')){
        stickyConfigure.setAttribute('data-cl-orig-text', stickyConfigure.textContent.trim());
      }
      stickyConfigure.textContent = 'Pick your setup';

      // Override the default data-configure scroll target. The theme's handler
      // scrolls to [data-product-info] which is the OUTER buy-box container
      // (title/price live inside it), so the user lands above the variant
      // chips. Capture-phase listener stops the theme handler and scrolls
      // directly to the variant options wrapper.
      stickyConfigure.addEventListener('click', function(e){
        if(swapped) return; // once we've stage-flipped, original ATC behavior
        var target = document.querySelector('.product__options')
                  || document.querySelector('[data-cl-control-picker]')
                  || document.querySelector('.product__option');
        if(!target) return; // fall back to theme handler
        e.preventDefault();
        e.stopImmediatePropagation();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, true);

      // Stage 2 trigger: hard scroll depth. Once the visitor has scrolled
      // SCROLL_THRESHOLD pixels down the page, they've engaged with the PDP
      // past the hero / price area and are at or past the variant selectors
      // on mobile. Permanently flip to ATC.
      var SCROLL_THRESHOLD = 500;
      var swapped = false;
      function swapToAtc(){
        if(swapped) return;
        swapped = true;
        document.documentElement.setAttribute('data-cl-sticky-stage','atc');
      }
      function onScroll(){
        if(window.scrollY >= SCROLL_THRESHOLD){
          swapToAtc();
          window.removeEventListener('scroll', onScroll);
        }
      }
      // Check in case the page loads already scrolled (back/forward nav).
      if(window.scrollY >= SCROLL_THRESHOLD) swapToAtc();
      else window.addEventListener('scroll', onScroll, { passive: true });

      return true;
    }
    if(attempt()) return;
    var tries=0, iv=setInterval(function(){ tries++; if(attempt()||tries>40) clearInterval(iv); },150);
  }

    function fire(arm){
      // Delegates to the shared helper which handles:
      //   - cro_test_<id>=<arm> cart attribute
      //   - dataLayer.push (unconditional)
      //   - gtag('event','ab_test_exposure') with 5s retry
      //   - stix.track.exposeTest (Klaviyo + TW)
      // Helper is idempotent per (testId, arm), so safe to invoke twice
      // (once right after assignment, once from the legacy call site).
      if (typeof window.stixCroExpose === 'function') {
        window.stixCroExpose(TEST_ID, arm, { page_type: 'pdp' });
        return;
      }
      // Inline fallback if stix-cro-expose.js failed to load.
      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'ab_test_exposure', cl_test_id: TEST_ID, cl_test_variant: arm,
          page_type: 'pdp', page_path: location.pathname
        });
      } catch (e) {}
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'attributes[cro_test_' + TEST_ID + ']=' + encodeURIComponent(arm),
          credentials: 'same-origin', keepalive: true
        }).catch(function(){});
      } catch (e) {}
    }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
